import { useMutation } from '@tanstack/react-query'
import { previewBrokeFlexMessageStage } from '../services'

export default function useMutationPreviewBrokeFlexMessageStage() {
	return useMutation({
		mutationFn: ({
			campaignId,
			stageId,
		}: {
			campaignId: string
			stageId: string
		}) => previewBrokeFlexMessageStage(campaignId, stageId),
	})
}
